import styled from "styled-components";
import rem from "./Utils";

// GENERAL CONTAINER COMPONENT
export const Container = styled.div`
  max-width: ${rem(940)};
  margin: 0 auto;
`;